import React, { useEffect, useState } from "react";
import "../styles/Hero.scss";

import h1 from "../assets/gallery/3D/1 (1).webp";
import h2 from "../assets/gallery/3D/1 (2).webp";
import img2 from "../assets/gallery/3D/1 (3).webp";
import img3 from '../assets/gallery/3D/1 (4).webp'

import waterfall from "../assets/video/waterfall.mp4";
// import sparrow from "../assets/video/sparrow.mp4";
// import butterfly from "../assets/video/butterfly.mp4";

export default function Hero() {
    const [activeIndex, setActiveIndex] = useState(0);

    const slides = [
        { type: "image", src: img2 },
        { type: "image", src: h2 },
        // { type: "video", src: waterfall },
        { type: "image", src: h1 },
        // { type: "video", src: butterfly },
        { type: "image", src: img3 },
        // { type: "video", src: sparrow }
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setActiveIndex(prev =>
                prev === slides.length - 1 ? 0 : prev + 1
            );
        }, 5000);

        return () => clearInterval(timer);
    }, []);

    const nextSlide = () => {
        setActiveIndex(prev =>
            prev === slides.length - 1 ? 0 : prev + 1
        );
    };

    const prevSlide = () => {
        setActiveIndex(prev =>
            prev === 0 ? slides.length - 1 : prev - 1
        );
    };

    return (
        <section className="lv-hero">

            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`lv-slide ${activeIndex === index ? "active" : ""
                        }`}
                >
                    {slide.type === "video" ? (
                        <video
                            autoPlay
                            muted
                            loop
                            playsInline
                        >
                            <source
                                src={slide.src}
                                type="video/mp4"
                            />
                        </video>
                    ) : (
                        <img src={slide.src} alt="" />
                    )}
                </div>
            ))}

            <div className="lv-overlay"></div>

            <div className="lv-content">

                <span className="lv-kicker">
                    LUXURY RESORT FARMHOUSE PLOTS
                </span>

                <h1>
                    Own a Piece of Paradise
                    <span> Near Lonavala</span>
                </h1>

                <p>
                    125 Acre gated community offering
                    premium Proposed Resort NA Farmhouse Plots
                    amidst breathtaking valleys,
                    waterfalls and nature.
                </p>

                <div className="lv-buttons">
                    <a href="#contact" className="primary">
                        Download Brochure
                    </a>

                    <a href="#contact" className="secondary">
                        Book Site Visit
                    </a>
                </div>

                <div className="lv-stats">

                    <div>
                        <h3>125</h3>
                        <span>Acres</span>
                    </div>

                    <div>
                        <h3>10,000</h3>
                        <span>Sq.ft Plots (Possession of 9,000 sq. ft.)</span>
                    </div>

                    <div>
                        <h3>4</h3>
                        <span>Acres of Resort (Paid Amenities) </span>
                    </div>

                </div>
            </div>

            <button
                className="hero-arrow prev"
                onClick={prevSlide}
            >
                ‹
            </button>

            <button
                className="hero-arrow next"
                onClick={nextSlide}
            >
                ›
            </button>

            <div className="hero-dots">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        className={
                            activeIndex === index
                                ? "dot active"
                                : "dot"
                        }
                        onClick={() =>
                            setActiveIndex(index)
                        }
                    />
                ))}
            </div>

        </section>
    );
}